import Vue from 'vue';
import DateSelectorInline from '@/components/Elements/DateSelectorInline';
import DurationSelectorInline from '@/components/Elements/DurationSelectorInline';
import WeekdaySelectorInline from '@/components/Elements/WeekdaySelectorInline';

// https://vuejs.org/v2/guide/components-registration.html#Local-Registration

let optionBase = Vue.extend({
  props: {
    value: {
      default: () => ({})
    }
  },
  template: `<div>NOT IMPLEMENTED</div>`,
  data() {
    return {
      dataFields: {}
    };
  },
  watch: {
    dataFields: {
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  created() {
    this.dataFields = Object.assign({}, this.value);
  },
  methods: {},
  components: {
    // DEFINE ALL COMONENTS HERE?
  }
});

export default [
  {
    label: 0,
    text: "invest <u>30 hours</u> in total",
    fields: {
      totalMinutes: 30 * 60,
      remainingTime: 30 * 60
    },
    component: optionBase.extend({
      template: `
      <span>
        invest
        <duration-selector-inline v-model="dataFields.totalMinutes" unit="hours" size="mini" />
        in total
      </span>`,
      watch: {
        'dataFields.totalMinutes'() {
          this.dataFields.remainingTime = this.dataFields.totalMinutes
        }
      },
      components: {
        DurationSelectorInline,
      }
    })
  },
  {
    label:  1,
    text: "invest <u>30 hours</u> until <u>a deadline</u>",
    fields: {
      totalMinutes: 30 * 60,
      remainingTime: 30 * 60,
      deadline: null
    },
    beforeUpdate(data) {
      // data.deadline = (new Date(data.deadline)).getTime();
      return data;
    },
    component: optionBase.extend({
      template: `
      <span>
        invest
        <duration-selector-inline v-model="dataFields.totalMinutes" unit="hours" size="mini" />
        in total until
        <date-selector-inline v-model="dataFields.deadline" placeholder="deadline" text_if_empty="forever" />
      </span>`,
      watch: {
        'dataFields.totalMinutes'() {
          this.dataFields.remainingTime = this.dataFields.totalMinutes
        }
      },
      components: {
        DurationSelectorInline,
        DateSelectorInline
      }
    })
  },
  {
    label:  2,
    text: "to this activity <u>every day</u> for <u>15 minutes</u>",
    // display: "Do {{name}} ",
    fields: {
      weekdays: [], // or '-------'
      durationMinutes: 15,
    },
    component: optionBase.extend({
      template: `
      <span>
        to this activity
        <div style="display: inline-block; line-height: 1em">
          <weekday-selector-inline size="mini" v-model="dataFields.weekdays" :humanize="true" />
        </div>
        for
        <duration-selector-inline v-model="dataFields.durationMinutes" unit="minutes" size="mini" />
      </span>`,
      // @save="onSave(pref.id, 'selectedWeekdays', $event)"
      components: {
        DurationSelectorInline,
        WeekdaySelectorInline
      }
    })
  },
  {
    label:  3,
    text: "to this activity <u @click=\"effortType='COMMITMENT'\">3 times</u> / <u>week</u> for <u>60 minutes</u>"
  },
  {
    label:  4,
    text: "to this activity <u>3 times</u> / <u>week</u> for <u>60 minutes</u> with <u>1 day</u> in between"
  },
  {
    label:  5,
    text: "to this activity <u>10 times</u> in total for <u>30 minutes</u>"
  },
  {
    label:  6,
    text: "invest <u>30 hours</u> over the next <u>30 days</u>"
  },
  {
    label:  7,
    text: "invest 10 hours / week until a <u>deadline</u>",
    fields: {
      deadline: new Date()
    },
    beforeUpdate(data) {
      // data.deadline = (new Date(data.deadline)).getTime();
      return data;
    },
    component: optionBase.extend({ // TODO: evtl nur template?
      template: `
      <span>invest 10 hours / week until a
        <date-selector-inline v-model="dataFields.deadline" placeholder="deadline" />
      </span>`,
      components: {
        DateSelectorInline
      }
    })
  },
  {
    label:  8,
    text: "invest <u>2 hours</u> / <u>day</u>  on <u>Mo, Tue, Wed, Thu, Fri</u> until a <u>deadline</u> "
  },
  {
    label:  9,
    text: "invest <u>2 hours</u> / <u>day</u>  on <u>Mo, Wed, Thu</u> between <u> 9:00 and 11:00am</u>"
  },
  {
    label: 10,
    text: "invest time based on a <u>routine</u> that I want to repeat <u>5 times</u>&nbsp; <u>in total</u>"
  },
];

/* [
  {label:  0, text: "invest <u>30 hours</u> in total", comp: 'commitment-option-1'},
  {label:  1, text: "invest <u>30 hours</u> until a <u>deadline</u>", comp: commitmentOption2},
  {label:  2, text: "to this activity <u>every day</u> for <u>15 minutes</u>"},
  {label:  3, text: "to this activity <u @click=\"effortType='COMMITMENT'\">3 times</u> / <u>week</u> for <u>60 minutes</u>"},
  {label:  4, text: "to this activity <u>3 times</u> / <u>week</u> for <u>60 minutes</u> with <u>1 day</u> in between"},
  {label:  5, text: "to this activity <u>10 times</u> in total for <u>30 minutes</u>"},
  {label:  6, text: "invest <u>30 hours</u> over the next <u>30 days</u>"},
  {label:  7, text: "invest 10 hours / week until a <u>deadline</u>"},
  {label:  8, text: "invest <u>2 hours</u> / <u>day</u>  on <u>Mo, Tue, Wed, Thu, Fri</u> until a <u>deadline</u> "},
  {label:  9, text: "invest <u>2 hours</u> / <u>day</u>  on <u>Mo, Wed, Thu</u> between <u> 9:00 and 11:00am</u>"},
  {label: 10, text: "invest time based on a <u>routine</u> that I want to repeat <u>5 times</u>&nbsp; <u>in total</u>"},
] */
